import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";
import { SiteCreateState } from "../SiteCreate";

import styles from "./KioskInstructionSection.module.scss";

import img_icon_info_icon from "@/Globals/_images/icons/info_icon.png";

interface IKioskInstructionSectionProps {
    localizedKioskInstruction: LocalizedTextDto;
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function KioskInstructionSection(props: Readonly<IKioskInstructionSectionProps>): JSX.Element {
    const { localizedKioskInstruction, mutateState } = props;

    const onChangeHandle = (value: string, propertyName: string): void => {
        mutateState(s => s.localizedKioskInstruction = {
            ...localizedKioskInstruction,
            [propertyName]: value
        });
    };

    return (
        <>
            <div className={`${styles.kioskSectionHeader} view-section-header`}>
                <h3 className="view-section-title">{cacheStore.GetString("ClinicInfo_KioskInstructionLabel")}</h3>
                <img
                    alt="Info-Icon"
                    className={styles.kioskSectionHeaderIcon}
                    src={img_icon_info_icon}
                    title={cacheStore.GetString("ClinicInfo_KioskInstructionIconInfo")}
                />
            </div>

            <div className="view-section-body">
                {AdministrationHelper.getLocalizedTextSiteCreateArray(localizedKioskInstruction).map(item => (
                    <div key={`kisokInstructions_${item.languageName}`} className={`row ${styles.kioskSectionRow}`}>
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{item.languageName}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <textarea
                                className="form-control"
                                value={item.value}
                                maxLength={AdministrationHelper.maxKioskInstructionLength}
                                onChange={e => {
                                    if (e.target.value.length > AdministrationHelper.maxKioskInstructionLength) {
                                        return;
                                    }
                                    onChangeHandle(e.target.value, item.propertyName);
                                }}
                            />
                            <label data-cy="counter-label">
                                {`${item.value?.length ?? 0}/${AdministrationHelper.maxKioskInstructionLength}`}
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { IKioskInstructionSectionProps };
export default KioskInstructionSection;
